import { BIRTH_RANK } from '../config/customer';

export const getWeight = (data) => {
  if (data.weight) return `${data.weight} kg`;
  if (!data.responses || !data.responses.length || !data.responses.fields)
    return 'Unknown kg';

  const field =
    data.responses[data.responses.length - 1].fields.find(
      (f) => f.label === 'Weight',
    ) ||
    data.responses[data.responses.length - 1].fields.find(
      (f) => f.label === 'Quel est votre poids en kg ?',
    );

  if (!field) return 'Unknown kg';

  return `${field['value']} kg`;
};

export const getHeight = (data) => {
  if (data.height) return `${data.height} cm`;
  if (!data.responses || !data.responses.length || !data.responses.fields)
    return 'Unknown cm';

  const field =
    data.responses[data.responses.length - 1].fields.find(
      (f) => f.label === 'Height',
    ) ||
    data.responses[data.responses.length - 1].fields.find(
      (f) => f.label === 'Quelle est votre taille en cm ?',
    );

  if (!field) return 'Unknown cm';

  return `${field['value']} cm`;
};

export const getAge = (data) => {
  if (data.age) return data.age;
  if (!data.responses || !data.responses.length || !data.responses.fields)
    return 'Unknown';

  const field =
    data.responses[data.responses.length - 1].fields.find(
      (f) => f.label === 'Age',
    ) ||
    data.responses[data.responses.length - 1].fields.find(
      (f) => f.label === 'Quel âge avez-vous ?',
    );

  if (!field) return 'Unknown';

  return field['value'];
};

export const getGender = (data) => {
  if (data.gender) return data.gender;
  if (!data.responses || !data.responses.length || !data.responses.fields)
    return 'Unknown';

  const field =
    data.responses[data.responses.length - 1].fields.find(
      (f) => f.label === 'Gender',
    ) ||
    data.responses[data.responses.length - 1].fields.find(
      (f) => f.label === 'Quel est votre sexe ?',
    );

  if (!field) return 'Unknown';

  return field['value'];
};

export const getBMI = (data) => {
  if (data.bmi) return data.bmi;
  if (!data.responses || !data.responses.length || !data.responses.fields)
    return 'Unknown';

  const field = data.responses[data.responses.length - 1].fields.find(
    (f) => f.label === 'BMI',
  );

  if (!field) return 'Unknown';

  return field['value'];
};

export const getBirthRank = (data) => {
  return BIRTH_RANK.find((b) => b.value === data.birthRank)?.label;
};
